import React, { Component } from 'react'; //different
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import moment from 'moment';

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            weekdays: [],
            userid: props.userid,   // only pick what you need
            weeksum: [],
            username: '',
            firstname: '',
            clicked: false,
            lastname: '',
            checkinsetting: [],
            checkinThisMonth: 0,
        }
        this.MILESTONES = [
            { days: 0, percent: 0 },
            { days: 3, percent: 25 },
            { days: 7, percent: 50 },
            { days: 15, percent: 75 },
            { days: 25, percent: 100 },
        ];
    }

    handleNav(to, e = { preventDefault: () => { } }) {
        // ถ้า e ถูกส่งมาจาก onClick ปกติ
        if (e?.preventDefault) e.preventDefault();

        // รองรับ ctrl / alt / middle click
        if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

        console.log("📍 Navigate to:", to);

        if (typeof this.props.onNavigate === "function") {
            this.props.onNavigate(to, e);
        } else {
            // fallback
            window.history.pushState(null, "", to);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    }
    async componentDidMount() {
        console.log("componentDidMount Cardgame prevState", this.props);
        this.getcheckin(this.props.userid);

    }
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access

        // Check if point has changed
        if (prevProps.point !== point) {
            if (point !== this.state.point) {
                console.log("componentDidUpdate - point updated:", point);
                this.setState({ point });
            }
        }

        // Check if username has changed
        if (prevProps.username !== userid) {
            if (userid !== this.state.userid) {
                console.log("componentDidUpdate - username updated:", userid);
                this.setState({ userid: userid });
                this.getcheckin(this.props.userid);
            }
        }
    }


    handleCheckIn = async (item, type, index) => {
        console.log('Check-in item clicked:', item, type);
        this.setState({ clicked: true })

        try {
            // สร้างข้อมูลใน object.rows ที่จำเป็น
            if (type === 1) {
                const isToday = moment().isSame(moment(item.dateStr), 'day'); // เช็คว่าเป็นวันนี้
                if (isToday) {
                    const rows = {
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        dateupdate: item.dateStr,
                        CheckinID: index,
                        status: 1,  // สถานะการเช็คอิน
                        // คุณสามารถเพิ่มข้อมูลเพิ่มเติมได้ตามที่ต้องการ
                    };

                    // ส่งข้อมูลไปยัง API
                    const response = await instance.post('/api/v1/postcheckinlist', {
                        System: Systems,
                        type: type,
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        rows: rows,
                    });

                    const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                    if (data.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'เช็คอินสำเร็จ',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }

                    else {
                        console.log('Check-in failed:', data);
                        await Swal.fire({
                            icon: 'warning',
                            title: 'เช็คอินไม่สำเร็จ',
                            text: data.message,
                        });
                        this.setState({ clicked: false })
                    }
                } else {
                    console.log('ไม่สามารถเช็คอินสำหรับวันที่นี้');
                    Swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถเช็คอินได้',
                        text: 'วันที่เช็คอินไม่ตรงกับวันนี้',
                    });
                }
            } else if (type === 2) {
                // ส่งข้อมูลไปยัง API สำหรับการรับรางวัลสะสม
                const response = await instance.post('/api/v1/postcheckinlist', {
                    System: Systems,
                    userid: this.state.userid,  // user ID ที่เช็คอิน
                    item: item,
                    type: type,
                    status: 1,  // สถานะการเช็คอิน
                });

                const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                if (data.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'รับรางวัลสะสมสำเร็จ',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    console.log('Reward redemption failed:', data);
                    Swal.fire({
                        icon: 'warning',
                        title: 'รับรางวัลไม่สำเร็จ',
                        text: data.message,
                    });
                }
            }
        }
        catch (error) {
            console.log('Error posting checkin:', error);
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาดในการเช็คอิน',
                text: error.message || 'กรุณาลองใหม่อีกครั้ง',
            });
        }
        this.getcheckin(this.state.userid); // ดึงข้อมูลการเช็คอินล่าสุด
    };

    getcheckin = async (username) => {
        try {
            await instance.post("/api/v1/getcheckin", {
                System: Systems,
                userid: username,
            }).then(async (res) => {
                console.log("getcheckin", res.data)



                if (res.data.status === 200) {
                    const datas = res.data;

                    if (datas.tblcheckinsetting.length > 0 && datas.tblcheckinsetting[0].status == 0) {
                        await Swal.fire({
                            icon: 'error',
                            title: 'เกมยังไม่เปิดให้บริการ',
                            showConfirmButton: true,
                            confirmButtonText: 'ตกลง'
                        });
                        this.handleNav('/event')
                    }
                    this.setState({
                        checkinThisMonth: datas.checkinThisMonth,
                        weekdays: datas.weekList.week,
                        weeksum: datas.weekList.weeksum,
                        checkinsetting: datas.tblcheckinsetting,
                    });

                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (error) {
            console.log(error)
        }
    }

    getPercentByDays(days) {
        const d = Number(days || 0);
        if (d <= 0) return 0;
        if (d >= 25) return 100;

        // หา segment ที่ days อยู่ระหว่าง point i และ i+1
        for (let i = 0; i < this.MILESTONES.length - 1; i++) {
            const a = this.MILESTONES[i];
            const b = this.MILESTONES[i + 1];
            if (d >= a.days && d <= b.days) {
                // linear interpolation
                const ratio = (d - a.days) / (b.days - a.days);
                const pct = a.percent + ratio * (b.percent - a.percent);
                return Math.round(pct * 100) / 100; // ปัด 2 ตำแหน่ง
            }
        }
        return 100;
    }

    getNearestMilestone(days) {
        const d = Number(days || 0);
        let last = this.MILESTONES[0];
        for (const m of this.MILESTONES) {
            if (d >= m.days) last = m;
            else break;
        }
        return last; // คืน object {days, percent}
    }
    render() {
        const { checkinThisMonth, weeksum, checkinsetting } = this.state;

        // สิ่งที่ควรใช้เป็น totalNeeded (ถ้าจาก setting ให้ดึงจาก checkinsetting หรือ weeksum)
        const current = Number(this.state.checkinThisMonth || 0);
        const percent = this.getPercentByDays(current);
        const nearest = this.getNearestMilestone(current);

        return (
            <>
                <div className="checkin-page">
                    {/* ===== Header / Condition ===== */}
                    <div className="checkin-hero">
                        <div className="checkin-title">เกม เช็คอิน</div>

                        <div className="checkin-condition">
                            <div className="checkin-condition__label">เงื่อนไข</div>
                            <div className="checkin-condition__text">
                                ทำยอดเติม <b>{checkinsetting[0]?.credit}</b>.- ขึ้นไป รับทุกวันเพียงเข้ามาเช็คอิน
                                พร้อมทั้งสะสมเพื่อรับรางวัลที่สูงขึ้น
                            </div>
                        </div>
                    </div>

                    {/* ===== Section: Daily ===== */}
                    <div className="checkin-card">
                        <div className="checkin-card__head">
                            <div className="checkin-card__headLeft">
                                <i className="fas fa-calendar-check" />
                                <div>
                                    <div className="checkin-card__title">เช็คอินประจำวัน</div>
                                    <div className="checkin-card__sub">กดรับได้เฉพาะ “วันนี้”</div>
                                </div>
                            </div>
                        </div>

                        <div className="checkin-card__body">
                            <ul className="checkin-grid">
                                {this.state.weekdays.map((item, index) => {
                                    const m = moment(item.dateStr);
                                    const isPast = m.isBefore(moment(), "day");
                                    const isToday = m.isSame(moment(), "day");
                                    const isFuture = m.isAfter(moment(), "day");

                                    const stateClass = [
                                        isToday ? "is-today" : "",
                                        isPast ? "is-past" : "",
                                        isFuture ? "is-future" : "",
                                        item.passed ? "is-passed" : "",
                                    ].join(" ");

                                    const disabled = isPast || isFuture || this.state.clicked || item.passed;

                                    return (
                                        <li key={item.dateStr || index} className="checkin-grid__item">
                                            <button
                                                type="button"
                                                onClick={() => (!item.passed ? this.handleCheckIn(item, 1, index) : null)}
                                                className={`checkin-day ${stateClass}`}
                                                disabled={disabled}
                                            >
                                                <div className="checkin-day__coinWrap">
                                                    <img
                                                        alt="coin"
                                                        className="checkin-day__coin"
                                                        src={
                                                            !item.passed
                                                                ? "https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-coin.png"
                                                                : "https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-checked.png"
                                                        }
                                                    />
                                                </div>

                                                <div className="checkin-day__point">+{item.credit}</div>

                                                <div className="checkin-day__date">
                                                    {isToday ? "วันนี้" : m.format("DD/MM")}
                                                </div>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>

                    {/* ===== Section: Monthly Collect ===== */}
                    <div className="checkin-card">
                        <div className="checkin-card__head">
                            <div className="checkin-card__headLeft">
                                <div>
                                    <div className="checkin-card__title">เช็คอินสะสมเดือนนี้</div>
                                    <div className="checkin-card__sub">สะสมครบตามเงื่อนไขเพื่อรับกล่องรางวัล</div>
                                </div>
                            </div>

                            <div className="checkin-counter">
                                <div className="checkin-counter__num">{checkinThisMonth}</div>
                                <div className="checkin-counter__unit">วัน</div>
                            </div>
                        </div>

                        <div className="checkin-card__body">
                            <ul className="checkin-rewardRow">
                                {weeksum.map((item, index) => {
                                    const disabled = item.passed || item.totalday > checkinThisMonth || this.state.clicked;
                                    const canApply = !disabled;

                                    return (
                                        <li key={index} className="checkin-rewardRow__item">
                                            <button
                                                type="button"
                                                onClick={() => this.handleCheckIn(item, 2)}
                                                className={`checkin-reward ${canApply ? "can-apply" : ""} ${item.passed ? "is-passed" : ""}`}
                                                disabled={disabled}
                                            >
                                                <div className="checkin-reward__boxWrap">
                                                    <img
                                                        alt="box"
                                                        className="checkin-reward__box"
                                                        src={
                                                            !item.passed
                                                                ? "https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-box.png"
                                                                : "https://cdn.javisx.com/image/c1daeee2-74c6-4e71-ab7c-9ae8f4c5b2d6.png"
                                                        }
                                                    />
                                                    <div className="checkin-reward__badge">
                                                        <div className="checkin-reward__badgeLabel">สูงสุด</div>
                                                        <div className="checkin-reward__badgeValue">{item.credit}฿</div>
                                                    </div>
                                                </div>

                                                <div className="checkin-reward__need">{item.totalday} วัน</div>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>

                            <div className="checkin-progress">
                                <div className="checkin-progress__text">{current}/25</div>
                                <div className="checkin-progress__bar">
                                    <div className="checkin-progress__fill" style={{ width: `${percent}%` }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );

    }
}
export default App;
